/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the client.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */
import * as runtime from "@prisma/client/runtime/client";
/**
 * Prisma Errors
 */
export const PrismaClientKnownRequestError = runtime.PrismaClientKnownRequestError;
export const PrismaClientUnknownRequestError = runtime.PrismaClientUnknownRequestError;
export const PrismaClientRustPanicError = runtime.PrismaClientRustPanicError;
export const PrismaClientInitializationError = runtime.PrismaClientInitializationError;
export const PrismaClientValidationError = runtime.PrismaClientValidationError;
/**
 * Re-export of sql-template-tag
 */
export const sql = runtime.sqltag;
export const empty = runtime.empty;
export const join = runtime.join;
export const raw = runtime.raw;
export const Sql = runtime.Sql;
/**
 * Decimal.js
 */
export const Decimal = runtime.Decimal;
export const getExtensionContext = runtime.Extensions.getExtensionContext;
/**
 * Prisma Client JS version: 7.10.0
 * Query Engine version: 0edf323efd1d98336f3f0a68684b56f689b900d3
 */
export const prismaVersion = {
    client: "7.10.0",
    engine: "0edf323efd1d98336f3f0a68684b56f689b900d3"
};
export const NullTypes = {
    DbNull: runtime.NullTypes.DbNull,
    JsonNull: runtime.NullTypes.JsonNull,
    AnyNull: runtime.NullTypes.AnyNull,
};
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull;
/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull;
/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull;
export const ModelName = {
    DeploymentConfig: 'DeploymentConfig',
    DeploymentSecret: 'DeploymentSecret',
    Org: 'Org',
    User: 'User',
    DeletedIdentityCutoff: 'DeletedIdentityCutoff',
    PendingKeyShred: 'PendingKeyShred',
    Membership: 'Membership',
    OrgInviteLink: 'OrgInviteLink',
    OrgInviteRedemption: 'OrgInviteRedemption',
    WaitlistEntry: 'WaitlistEntry',
    Daemon: 'Daemon',
    DaemonLifecycleOp: 'DaemonLifecycleOp',
    ApiKey: 'ApiKey',
    OAuthClient: 'OAuthClient',
    OAuthCode: 'OAuthCode',
    OAuthGrant: 'OAuthGrant',
    RuntimeProfile: 'RuntimeProfile',
    MemberSet: 'MemberSet',
    MemberSetMember: 'MemberSetMember',
    Agent: 'Agent',
    PresetAgent: 'PresetAgent',
    AgentSecret: 'AgentSecret',
    AgentRepoAuthorization: 'AgentRepoAuthorization',
    CodeHostRepository: 'CodeHostRepository',
    CodeHostRepositoryClaim: 'CodeHostRepositoryClaim',
    CodeHostTrustedActor: 'CodeHostTrustedActor',
    Assignment: 'Assignment',
    SessionMeta: 'SessionMeta',
    SessionPullRequest: 'SessionPullRequest',
    SessionPullRequestCapture: 'SessionPullRequestCapture',
    ExternalScope: 'ExternalScope',
    SessionExternalAccessPolicy: 'SessionExternalAccessPolicy',
    WebchatConversation: 'WebchatConversation',
    WebchatConversationAgent: 'WebchatConversationAgent',
    WebchatMcpDelegation: 'WebchatMcpDelegation',
    WebchatMcpAccessGrant: 'WebchatMcpAccessGrant',
    WebchatMcpOperation: 'WebchatMcpOperation',
    WebchatMcpTransportReceipt: 'WebchatMcpTransportReceipt',
    SessionUsage: 'SessionUsage',
    SessionSpend: 'SessionSpend',
    AgentLaunch: 'AgentLaunch',
    SecretLease: 'SecretLease',
    CronDef: 'CronDef',
    CronRun: 'CronRun',
    HookDef: 'HookDef',
    HookSecret: 'HookSecret',
    HookRun: 'HookRun',
    HookReviewProjection: 'HookReviewProjection',
    CodeHostReviewLease: 'CodeHostReviewLease',
    CodeHostReviewOperation: 'CodeHostReviewOperation',
    CodeHostReviewAttemptOutcome: 'CodeHostReviewAttemptOutcome',
    HookReviewSubject: 'HookReviewSubject',
    CodeHostRunProjection: 'CodeHostRunProjection',
    Relay: 'Relay',
    Bot: 'Bot',
    BotSecret: 'BotSecret',
    SharedThreadAgent: 'SharedThreadAgent',
    SharedThreadParticipant: 'SharedThreadParticipant',
    Integration: 'Integration',
    IntegrationChannel: 'IntegrationChannel',
    SlackInstall: 'SlackInstall',
    SlackPlatformInstall: 'SlackPlatformInstall',
    FeishuAppRegistration: 'FeishuAppRegistration',
    SlackUserConfig: 'SlackUserConfig',
    LinearToken: 'LinearToken',
    LinearInstallState: 'LinearInstallState',
    AuditEvent: 'AuditEvent',
    GithubInstallation: 'GithubInstallation',
    GithubInstallState: 'GithubInstallState',
    GitlabConnection: 'GitlabConnection',
    GitlabConnectionSecret: 'GitlabConnectionSecret',
    GitlabProjectBinding: 'GitlabProjectBinding',
    GitlabAgentAccount: 'GitlabAgentAccount',
    GitlabAccountMembership: 'GitlabAccountMembership',
    GitlabProjectCredential: 'GitlabProjectCredential',
    GitlabProjectCredentialSecret: 'GitlabProjectCredentialSecret',
    GitlabWebhookSecret: 'GitlabWebhookSecret',
    GitlabOauthState: 'GitlabOauthState',
    GitlabInstanceState: 'GitlabInstanceState',
    GiteaConnection: 'GiteaConnection',
    GiteaConnectionSecret: 'GiteaConnectionSecret',
    GiteaRepositoryBinding: 'GiteaRepositoryBinding',
    GiteaWebhookSecret: 'GiteaWebhookSecret',
    McpProvider: 'McpProvider',
    McpProviderSecret: 'McpProviderSecret',
    McpGrant: 'McpGrant',
    McpProviderOauth: 'McpProviderOauth',
    McpProviderOauthSecret: 'McpProviderOauthSecret',
    McpProviderOauthState: 'McpProviderOauthState',
    SkillSource: 'SkillSource',
    OrganizationEnvironmentEntry: 'OrganizationEnvironmentEntry',
    OrganizationEnvironmentSecret: 'OrganizationEnvironmentSecret',
    OrganizationEnvironmentAssignment: 'OrganizationEnvironmentAssignment',
    OrganizationKnowledge: 'OrganizationKnowledge',
    OrganizationKnowledgeRevision: 'OrganizationKnowledgeRevision',
    ManagedSkill: 'ManagedSkill',
    ManagedSkillRevision: 'ManagedSkillRevision',
    OrganizationSuggestion: 'OrganizationSuggestion',
    MemoryPluginInstallation: 'MemoryPluginInstallation',
    ExternalMemoryConnection: 'ExternalMemoryConnection',
    ExternalMemoryConnectionSecret: 'ExternalMemoryConnectionSecret',
    ExternalMemoryGrant: 'ExternalMemoryGrant',
    DutyGroup: 'DutyGroup',
    DutyGroupMember: 'DutyGroupMember',
    AgentMemoryFile: 'AgentMemoryFile',
    AgentMemoryHistory: 'AgentMemoryHistory',
    AgentMemoryMutation: 'AgentMemoryMutation'
};
/**
 * Enums
 */
export const TransactionIsolationLevel = runtime.makeStrictEnum({
    ReadUncommitted: 'ReadUncommitted',
    ReadCommitted: 'ReadCommitted',
    RepeatableRead: 'RepeatableRead',
    Serializable: 'Serializable'
});
export const DeploymentConfigScalarFieldEnum = {
    id: 'id',
    schemaVersion: 'schemaVersion',
    values: 'values',
    revision: 'revision',
    adminClaimedFor: 'adminClaimedFor',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DeploymentSecretScalarFieldEnum = {
    deploymentConfigId: 'deploymentConfigId',
    key: 'key',
    value: 'value',
    fingerprint: 'fingerprint',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const OrgScalarFieldEnum = {
    id: 'id',
    name: 'name',
    slug: 'slug',
    createdByUserId: 'createdByUserId',
    icon: 'icon',
    defaultAgentVisibility: 'defaultAgentVisibility',
    onboardingCompleted: 'onboardingCompleted',
    gettingStartedStep: 'gettingStartedStep',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const UserScalarFieldEnum = {
    id: 'id',
    email: 'email',
    displayName: 'displayName',
    picture: 'picture',
    profilePictureUpdatedAt: 'profilePictureUpdatedAt',
    oidcSubject: 'oidcSubject',
    activatedAt: 'activatedAt',
    createdAt: 'createdAt'
};
export const DeletedIdentityCutoffScalarFieldEnum = {
    oidcSubject: 'oidcSubject',
    cutoffAt: 'cutoffAt',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt'
};
export const PendingKeyShredScalarFieldEnum = {
    orgId: 'orgId',
    mount: 'mount',
    keyName: 'keyName',
    createdAt: 'createdAt'
};
export const MembershipScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    userId: 'userId',
    role: 'role',
    createdAt: 'createdAt',
    lastSelectedAt: 'lastSelectedAt'
};
export const OrgInviteLinkScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    tokenHash: 'tokenHash',
    displayTail: 'displayTail',
    expiresAt: 'expiresAt',
    revokedAt: 'revokedAt',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt'
};
export const OrgInviteRedemptionScalarFieldEnum = {
    inviteLinkId: 'inviteLinkId',
    userId: 'userId',
    redeemedAt: 'redeemedAt'
};
export const WaitlistEntryScalarFieldEnum = {
    id: 'id',
    name: 'name',
    email: 'email',
    status: 'status',
    note: 'note',
    source: 'source',
    tokenHash: 'tokenHash',
    displayTail: 'displayTail',
    joinExpiresAt: 'joinExpiresAt',
    revokedAt: 'revokedAt',
    approvedByUserId: 'approvedByUserId',
    approvedAt: 'approvedAt',
    redeemedByUserId: 'redeemedByUserId',
    redeemedAt: 'redeemedAt',
    redeemedEmail: 'redeemedEmail',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DaemonScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    host: 'host',
    name: 'name',
    agentVersion: 'agentVersion',
    machineId: 'machineId',
    tokenFp: 'tokenFp',
    clusterIdentity: 'clusterIdentity',
    clusterPodUid: 'clusterPodUid',
    attestationFp: 'attestationFp',
    capabilities: 'capabilities',
    generation: 'generation',
    generationSince: 'generationSince',
    mcpServers: 'mcpServers',
    maxAgents: 'maxAgents',
    createdByUserId: 'createdByUserId',
    lastModifiedByUserId: 'lastModifiedByUserId',
    lastModifiedAt: 'lastModifiedAt',
    visibility: 'visibility',
    sharedWith: 'sharedWith',
    sessionRetention: 'sessionRetention',
    sessionEpoch: 'sessionEpoch',
    routingEpoch: 'routingEpoch',
    runtimesSnapshotSeq: 'runtimesSnapshotSeq',
    status: 'status',
    health: 'health',
    load: 'load',
    activeSessions: 'activeSessions',
    degradedScopes: 'degradedScopes',
    lastSeenAt: 'lastSeenAt',
    unreachableAt: 'unreachableAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DaemonLifecycleOpScalarFieldEnum = {
    id: 'id',
    daemonId: 'daemonId',
    op: 'op',
    targetVersion: 'targetVersion',
    initiator: 'initiator',
    status: 'status',
    phase: 'phase',
    commandEpoch: 'commandEpoch',
    acceptedAt: 'acceptedAt',
    startedAt: 'startedAt',
    deadline: 'deadline',
    outcome: 'outcome',
    settledAt: 'settledAt',
    createdAt: 'createdAt'
};
export const ApiKeyScalarFieldEnum = {
    id: 'id',
    principalType: 'principalType',
    orgId: 'orgId',
    daemonId: 'daemonId',
    userId: 'userId',
    hash: 'hash',
    displayTail: 'displayTail',
    name: 'name',
    scopes: 'scopes',
    createdByUserId: 'createdByUserId',
    oauthGrantId: 'oauthGrantId',
    createdAt: 'createdAt',
    lastUsedAt: 'lastUsedAt',
    expiresAt: 'expiresAt',
    revokedAt: 'revokedAt',
    revokedReason: 'revokedReason'
};
export const OAuthClientScalarFieldEnum = {
    clientId: 'clientId',
    clientName: 'clientName',
    redirectUris: 'redirectUris',
    grantTypes: 'grantTypes',
    createdAt: 'createdAt',
    expiresAt: 'expiresAt'
};
export const OAuthCodeScalarFieldEnum = {
    codeHash: 'codeHash',
    clientId: 'clientId',
    redirectUri: 'redirectUri',
    userId: 'userId',
    orgId: 'orgId',
    scopes: 'scopes',
    codeChallenge: 'codeChallenge',
    codeChallengeMethod: 'codeChallengeMethod',
    resource: 'resource',
    createdAt: 'createdAt',
    expiresAt: 'expiresAt',
    consumedAt: 'consumedAt'
};
export const OAuthGrantScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    orgId: 'orgId',
    clientId: 'clientId',
    scopes: 'scopes',
    resource: 'resource',
    rtHash: 'rtHash',
    prevRtHash: 'prevRtHash',
    rtExpiresAt: 'rtExpiresAt',
    createdAt: 'createdAt',
    lastUsedAt: 'lastUsedAt',
    revokedAt: 'revokedAt'
};
export const RuntimeProfileScalarFieldEnum = {
    id: 'id',
    daemonId: 'daemonId',
    runtime: 'runtime',
    aliasOf: 'aliasOf',
    version: 'version',
    hostVersion: 'hostVersion',
    hostAvailable: 'hostAvailable',
    credentialsConfigured: 'credentialsConfigured',
    models: 'models',
    contextWindow: 'contextWindow',
    acpSupport: 'acpSupport',
    acpProtocolVersion: 'acpProtocolVersion',
    toolCalling: 'toolCalling',
    mcpCapabilities: 'mcpCapabilities',
    modelCatalog: 'modelCatalog',
    modelsSource: 'modelsSource',
    authRequired: 'authRequired',
    unavailableReason: 'unavailableReason',
    observedAt: 'observedAt'
};
export const MemberSetScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    name: 'name',
    createdAt: 'createdAt'
};
export const MemberSetMemberScalarFieldEnum = {
    setId: 'setId',
    daemonId: 'daemonId',
    joinedAt: 'joinedAt'
};
export const AgentScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    name: 'name',
    displayName: 'displayName',
    icon: 'icon',
    description: 'description',
    runtime: 'runtime',
    status: 'status',
    placementKind: 'placementKind',
    daemonId: 'daemonId',
    setId: 'setId',
    placementChangedAt: 'placementChangedAt',
    workspaceMode: 'workspaceMode',
    workspaceIsolation: 'workspaceIsolation',
    gitRepo: 'gitRepo',
    gitBranch: 'gitBranch',
    agentDir: 'agentDir',
    gitCredentialProvider: 'gitCredentialProvider',
    installationId: 'installationId',
    workspaceRepoId: 'workspaceRepoId',
    gitAccess: 'gitAccess',
    capabilities: 'capabilities',
    permissions: 'permissions',
    runtimeOverrides: 'runtimeOverrides',
    managedSkills: 'managedSkills',
    createdByUserId: 'createdByUserId',
    lastModifiedByUserId: 'lastModifiedByUserId',
    lastModifiedAt: 'lastModifiedAt',
    visibility: 'visibility',
    sharedWith: 'sharedWith',
    callPolicy: 'callPolicy',
    allowedCallerAgentIds: 'allowedCallerAgentIds',
    outboundPolicy: 'outboundPolicy',
    allowedTargetAgentIds: 'allowedTargetAgentIds',
    introduceOnJoin: 'introduceOnJoin',
    runInSandbox: 'runInSandbox',
    configRevision: 'configRevision',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PresetAgentScalarFieldEnum = {
    orgId: 'orgId',
    preset: 'preset',
    agentId: 'agentId',
    status: 'status',
    placementSettledAt: 'placementSettledAt',
    createdAt: 'createdAt'
};
export const AgentSecretScalarFieldEnum = {
    agentId: 'agentId',
    key: 'key',
    value: 'value',
    updatedAt: 'updatedAt'
};
export const AgentRepoAuthorizationScalarFieldEnum = {
    id: 'id',
    agentId: 'agentId',
    provider: 'provider',
    repoId: 'repoId',
    repoFullName: 'repoFullName',
    access: 'access',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt'
};
export const CodeHostRepositoryScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    provider: 'provider',
    externalId: 'externalId',
    displayPath: 'displayPath',
    cloneUrl: 'cloneUrl',
    defaultBranch: 'defaultBranch',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CodeHostRepositoryClaimScalarFieldEnum = {
    id: 'id',
    provider: 'provider',
    externalId: 'externalId',
    orgId: 'orgId',
    bindingRef: 'bindingRef',
    generation: 'generation',
    state: 'state',
    tombstone: 'tombstone',
    opOwner: 'opOwner',
    opLeaseUntil: 'opLeaseUntil',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CodeHostTrustedActorScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    provider: 'provider',
    repoExternalId: 'repoExternalId',
    actorExternalId: 'actorExternalId',
    actorLogin: 'actorLogin',
    addedByUserId: 'addedByUserId',
    createdAt: 'createdAt'
};
export const AssignmentScalarFieldEnum = {
    id: 'id',
    platform: 'platform',
    channel: 'channel',
    thread: 'thread',
    threadKey: 'threadKey',
    agentId: 'agentId',
    daemonId: 'daemonId',
    workspaceId: 'workspaceId',
    assignedEpoch: 'assignedEpoch',
    assignedSeq: 'assignedSeq',
    routingEpoch: 'routingEpoch',
    state: 'state',
    bindRules: 'bindRules',
    releasedAt: 'releasedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SessionMetaScalarFieldEnum = {
    id: 'id',
    parentSessionId: 'parentSessionId',
    agentId: 'agentId',
    launchId: 'launchId',
    platform: 'platform',
    channel: 'channel',
    thread: 'thread',
    tenantScope: 'tenantScope',
    phase: 'phase',
    link: 'link',
    summary: 'summary',
    title: 'title',
    status: 'status',
    triggeredBy: 'triggeredBy',
    channelName: 'channelName',
    triggeredByName: 'triggeredByName',
    hookKind: 'hookKind',
    threadUrl: 'threadUrl',
    runtime: 'runtime',
    model: 'model',
    effort: 'effort',
    fastMode: 'fastMode',
    permissionMode: 'permissionMode',
    outputMode: 'outputMode',
    daemonId: 'daemonId',
    contentSetId: 'contentSetId',
    workspaceIsolation: 'workspaceIsolation',
    activityState: 'activityState',
    orgId: 'orgId',
    visibility: 'visibility',
    ownerIdentity: 'ownerIdentity',
    visibilitySource: 'visibilitySource',
    visibilityRev: 'visibilityRev',
    visibilityAckedRev: 'visibilityAckedRev',
    externalProvider: 'externalProvider',
    externalScopeId: 'externalScopeId',
    externalResolution: 'externalResolution',
    classifiedPolicyRev: 'classifiedPolicyRev',
    legacyUnresolved: 'legacyUnresolved',
    contentPurgedAt: 'contentPurgedAt',
    contentPurgedReason: 'contentPurgedReason',
    lastActivityAt: 'lastActivityAt',
    startedAt: 'startedAt',
    endedAt: 'endedAt',
    updatedAt: 'updatedAt'
};
export const SessionPullRequestScalarFieldEnum = {
    orgId: 'orgId',
    repoId: 'repoId',
    pullNumber: 'pullNumber',
    installationId: 'installationId',
    repoFullName: 'repoFullName',
    sessionId: 'sessionId',
    deliveryKey: 'deliveryKey',
    nextAttemptAt: 'nextAttemptAt',
    claimOwner: 'claimOwner',
    claimUntil: 'claimUntil',
    signalAt: 'signalAt'
};
export const SessionPullRequestCaptureScalarFieldEnum = {
    sessionId: 'sessionId',
    nextAttemptAt: 'nextAttemptAt',
    claimOwner: 'claimOwner',
    claimUntil: 'claimUntil'
};
export const ExternalScopeScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    provider: 'provider',
    realmKey: 'realmKey',
    resourceKind: 'resourceKind',
    resourceKey: 'resourceKey',
    credentialKind: 'credentialKind',
    credentialId: 'credentialId',
    aclRevision: 'aclRevision',
    revokedAt: 'revokedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SessionExternalAccessPolicyScalarFieldEnum = {
    orgId: 'orgId',
    provider: 'provider',
    state: 'state',
    currentRev: 'currentRev',
    readFenceRev: 'readFenceRev',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const WebchatConversationScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    userId: 'userId',
    delegationGeneration: 'delegationGeneration',
    currentSessionId: 'currentSessionId',
    currentSessionRev: 'currentSessionRev',
    targetSessionId: 'targetSessionId',
    createdAt: 'createdAt'
};
export const WebchatConversationAgentScalarFieldEnum = {
    conversationId: 'conversationId',
    agentId: 'agentId',
    role: 'role',
    ord: 'ord',
    addedByUserId: 'addedByUserId',
    addedAt: 'addedAt',
    currentSessionId: 'currentSessionId',
    currentSessionRev: 'currentSessionRev'
};
export const WebchatMcpDelegationScalarFieldEnum = {
    id: 'id',
    conversationId: 'conversationId',
    generation: 'generation',
    userId: 'userId',
    orgId: 'orgId',
    agentId: 'agentId',
    createdAt: 'createdAt',
    expiresAt: 'expiresAt',
    revokedAt: 'revokedAt',
    revokedReason: 'revokedReason'
};
export const WebchatMcpAccessGrantScalarFieldEnum = {
    id: 'id',
    authorityId: 'authorityId',
    descriptorInstanceId: 'descriptorInstanceId',
    grantRevision: 'grantRevision',
    tokenHash: 'tokenHash',
    status: 'status',
    pendingExpiresAt: 'pendingExpiresAt',
    expiresAt: 'expiresAt',
    activatedAt: 'activatedAt',
    revokedAt: 'revokedAt',
    revokedReason: 'revokedReason',
    createdAt: 'createdAt'
};
export const WebchatMcpOperationScalarFieldEnum = {
    id: 'id',
    conversationId: 'conversationId',
    createdAuthorityGeneration: 'createdAuthorityGeneration',
    sourceGrantId: 'sourceGrantId',
    userId: 'userId',
    toolName: 'toolName',
    canonicalArguments: 'canonicalArguments',
    intentHash: 'intentHash',
    status: 'status',
    executionAttemptId: 'executionAttemptId',
    claimedAt: 'claimedAt',
    recoveryDeadline: 'recoveryDeadline',
    boundedResponse: 'boundedResponse',
    createdAt: 'createdAt',
    confirmationExpiresAt: 'confirmationExpiresAt',
    completedAt: 'completedAt'
};
export const WebchatMcpTransportReceiptScalarFieldEnum = {
    grantId: 'grantId',
    jsonRpcRequestId: 'jsonRpcRequestId',
    conversationId: 'conversationId',
    requestHash: 'requestHash',
    operationId: 'operationId',
    createdAt: 'createdAt',
    supersededAt: 'supersededAt'
};
export const SessionUsageScalarFieldEnum = {
    agentId: 'agentId',
    sessionId: 'sessionId',
    platform: 'platform',
    channel: 'channel',
    source: 'source',
    totalTokens: 'totalTokens',
    inputTokens: 'inputTokens',
    outputTokens: 'outputTokens',
    thoughtTokens: 'thoughtTokens',
    cachedReadTokens: 'cachedReadTokens',
    cachedWriteTokens: 'cachedWriteTokens',
    contextUsed: 'contextUsed',
    contextSize: 'contextSize',
    costAmount: 'costAmount',
    costCurrency: 'costCurrency',
    startedAt: 'startedAt',
    lastActivityAt: 'lastActivityAt',
    updatedAt: 'updatedAt'
};
export const SessionSpendScalarFieldEnum = {
    agentId: 'agentId',
    sessionId: 'sessionId',
    at: 'at',
    model: 'model',
    source: 'source',
    cumulativeTotalTokens: 'cumulativeTotalTokens',
    cumulativeInputTokens: 'cumulativeInputTokens',
    cumulativeOutputTokens: 'cumulativeOutputTokens',
    cumulativeThoughtTokens: 'cumulativeThoughtTokens',
    cumulativeCachedReadTokens: 'cumulativeCachedReadTokens',
    cumulativeCachedWriteTokens: 'cumulativeCachedWriteTokens',
    cumulativeCost: 'cumulativeCost'
};
export const AgentLaunchScalarFieldEnum = {
    id: 'id',
    agentId: 'agentId',
    daemonId: 'daemonId',
    runtime: 'runtime',
    mode: 'mode',
    acpSessionId: 'acpSessionId',
    correlationId: 'correlationId',
    createdByUserId: 'createdByUserId',
    activeCapabilities: 'activeCapabilities',
    status: 'status',
    launchEpoch: 'launchEpoch',
    startedAt: 'startedAt',
    stoppedAt: 'stoppedAt',
    createdAt: 'createdAt'
};
export const SecretLeaseScalarFieldEnum = {
    id: 'id',
    daemonId: 'daemonId',
    scopePlatform: 'scopePlatform',
    scopeWorkspaceId: 'scopeWorkspaceId',
    ref: 'ref',
    ttlSec: 'ttlSec',
    renewBeforeSec: 'renewBeforeSec',
    status: 'status',
    issuedAt: 'issuedAt',
    renewedAt: 'renewedAt',
    expiresAt: 'expiresAt',
    revokedReason: 'revokedReason'
};
export const CronDefScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    name: 'name',
    schedule: 'schedule',
    timezone: 'timezone',
    targetPlatform: 'targetPlatform',
    targetChannel: 'targetChannel',
    targetIntegrationId: 'targetIntegrationId',
    trigger: 'trigger',
    enabled: 'enabled',
    lastRunAt: 'lastRunAt',
    createdByUserId: 'createdByUserId',
    lastModifiedByUserId: 'lastModifiedByUserId',
    lastModifiedAt: 'lastModifiedAt',
    visibility: 'visibility',
    sharedWith: 'sharedWith',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CronRunScalarFieldEnum = {
    id: 'id',
    cronId: 'cronId',
    orgId: 'orgId',
    startedAt: 'startedAt',
    status: 'status',
    durationMs: 'durationMs',
    sessionId: 'sessionId',
    reason: 'reason',
    createdAt: 'createdAt'
};
export const HookDefScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    kind: 'kind',
    name: 'name',
    enabled: 'enabled',
    sessionMode: 'sessionMode',
    urlToken: 'urlToken',
    repoId: 'repoId',
    repoFullName: 'repoFullName',
    githubSessionKey: 'githubSessionKey',
    family: 'family',
    events: 'events',
    commentFamilies: 'commentFamilies',
    labelFilter: 'labelFilter',
    mentionOnly: 'mentionOnly',
    configRevision: 'configRevision',
    dispatchRevision: 'dispatchRevision',
    projectionEpoch: 'projectionEpoch',
    reviewPolicy: 'reviewPolicy',
    reportingMode: 'reportingMode',
    gateMode: 'gateMode',
    requiredAcknowledgedAt: 'requiredAcknowledgedAt',
    requiredAcknowledgedByUserId: 'requiredAcknowledgedByUserId',
    requiredAcknowledgedConfigRevision: 'requiredAcknowledgedConfigRevision',
    targetPlatform: 'targetPlatform',
    targetChannel: 'targetChannel',
    targetIntegrationId: 'targetIntegrationId',
    lastFiredAt: 'lastFiredAt',
    createdByUserId: 'createdByUserId',
    lastModifiedByUserId: 'lastModifiedByUserId',
    lastModifiedAt: 'lastModifiedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const HookSecretScalarFieldEnum = {
    hookId: 'hookId',
    hmacSecret: 'hmacSecret'
};
export const HookRunScalarFieldEnum = {
    id: 'id',
    hookId: 'hookId',
    orgId: 'orgId',
    deliveryKey: 'deliveryKey',
    event: 'event',
    startedAt: 'startedAt',
    agentId: 'agentId',
    configRevision: 'configRevision',
    dispatchRevision: 'dispatchRevision',
    projectionEpoch: 'projectionEpoch',
    dispatchDaemonId: 'dispatchDaemonId',
    reviewPolicySnapshot: 'reviewPolicySnapshot',
    reportingModeSnapshot: 'reportingModeSnapshot',
    gateModeSnapshot: 'gateModeSnapshot',
    projectionIntent: 'projectionIntent',
    repoId: 'repoId',
    repoFullName: 'repoFullName',
    sourceInstallationId: 'sourceInstallationId',
    subjectKind: 'subjectKind',
    pullNumber: 'pullNumber',
    headSha: 'headSha',
    baseSha: 'baseSha',
    reportSha: 'reportSha',
    isDraft: 'isDraft',
    baseChanged: 'baseChanged',
    turnStartedAt: 'turnStartedAt',
    completedAt: 'completedAt',
    orphanedAt: 'orphanedAt',
    projectionId: 'projectionId',
    projectionGeneration: 'projectionGeneration',
    reviewAttemptId: 'reviewAttemptId',
    reviewAttemptState: 'reviewAttemptState',
    reviewErrorCode: 'reviewErrorCode',
    reviewId: 'reviewId',
    reviewEvent: 'reviewEvent',
    verdict: 'verdict',
    reviewCommitId: 'reviewCommitId',
    publishedCommentKind: 'publishedCommentKind',
    publishedCommentId: 'publishedCommentId',
    status: 'status',
    durationMs: 'durationMs',
    sessionId: 'sessionId',
    reason: 'reason',
    redeliveryAttempts: 'redeliveryAttempts',
    redeliveryLastRequestedAt: 'redeliveryLastRequestedAt',
    redeliveryNextAttemptAt: 'redeliveryNextAttemptAt',
    createdAt: 'createdAt'
};
export const HookReviewProjectionScalarFieldEnum = {
    id: 'id',
    hookId: 'hookId',
    orgId: 'orgId',
    agentId: 'agentId',
    agentName: 'agentName',
    lastResolvedInstallationId: 'lastResolvedInstallationId',
    repoId: 'repoId',
    repoFullName: 'repoFullName',
    headSha: 'headSha',
    reportSha: 'reportSha',
    projectionEpoch: 'projectionEpoch',
    generation: 'generation',
    currentHookRunId: 'currentHookRunId',
    externalId: 'externalId',
    checkRunId: 'checkRunId',
    mode: 'mode',
    gateMode: 'gateMode',
    desiredState: 'desiredState',
    observedState: 'observedState',
    sealedThrough: 'sealedThrough',
    subjectSyncGeneration: 'subjectSyncGeneration',
    subjectSyncErrorCode: 'subjectSyncErrorCode',
    leaseOwner: 'leaseOwner',
    leaseUntil: 'leaseUntil',
    nextAttemptAt: 'nextAttemptAt',
    attempts: 'attempts',
    lastErrorCode: 'lastErrorCode',
    pendingIntent: 'pendingIntent',
    writeMarker: 'writeMarker',
    writePhase: 'writePhase',
    writeStartedAt: 'writeStartedAt',
    tombstonedAt: 'tombstonedAt',
    updatedAt: 'updatedAt'
};
export const CodeHostReviewLeaseScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    provider: 'provider',
    projectExternalId: 'projectExternalId',
    mergeRequestIid: 'mergeRequestIid',
    serviceAccountExternalId: 'serviceAccountExternalId',
    fence: 'fence',
    attemptId: 'attemptId',
    ownerDaemonId: 'ownerDaemonId',
    agentId: 'agentId',
    hookId: 'hookId',
    deliveryKey: 'deliveryKey',
    event: 'event',
    verdict: 'verdict',
    headSha: 'headSha',
    phase: 'phase',
    leaseUntil: 'leaseUntil',
    lockedReason: 'lockedReason',
    lockedAt: 'lockedAt',
    markerSeed: 'markerSeed',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CodeHostReviewOperationScalarFieldEnum = {
    id: 'id',
    leaseId: 'leaseId',
    orgId: 'orgId',
    attemptId: 'attemptId',
    fence: 'fence',
    ordinal: 'ordinal',
    kind: 'kind',
    method: 'method',
    target: 'target',
    state: 'state',
    startToken: 'startToken',
    responseStatus: 'responseStatus',
    responseExternalId: 'responseExternalId',
    resultCode: 'resultCode',
    issuedAt: 'issuedAt',
    startedAt: 'startedAt',
    ambiguousAt: 'ambiguousAt',
    settledAt: 'settledAt'
};
export const CodeHostReviewAttemptOutcomeScalarFieldEnum = {
    attemptId: 'attemptId',
    orgId: 'orgId',
    hookId: 'hookId',
    deliveryKey: 'deliveryKey',
    provider: 'provider',
    projectExternalId: 'projectExternalId',
    mergeRequestIid: 'mergeRequestIid',
    event: 'event',
    verdict: 'verdict',
    headSha: 'headSha',
    state: 'state',
    externalIds: 'externalIds',
    recordedAt: 'recordedAt',
    updatedAt: 'updatedAt'
};
export const HookReviewSubjectScalarFieldEnum = {
    projectionId: 'projectionId',
    pullNumber: 'pullNumber',
    headSha: 'headSha',
    baseSha: 'baseSha',
    isOpen: 'isOpen',
    updatedAt: 'updatedAt'
};
export const CodeHostRunProjectionScalarFieldEnum = {
    id: 'id',
    provider: 'provider',
    hookId: 'hookId',
    orgId: 'orgId',
    agentId: 'agentId',
    agentName: 'agentName',
    projectId: 'projectId',
    projectPath: 'projectPath',
    mergeRequestIid: 'mergeRequestIid',
    headSha: 'headSha',
    projectionEpoch: 'projectionEpoch',
    generation: 'generation',
    currentDeliveryKey: 'currentDeliveryKey',
    currentRunAt: 'currentRunAt',
    externalId: 'externalId',
    noteId: 'noteId',
    desiredState: 'desiredState',
    observedState: 'observedState',
    reason: 'reason',
    sealedThrough: 'sealedThrough',
    queuedAt: 'queuedAt',
    startedAt: 'startedAt',
    completedAt: 'completedAt',
    sessionId: 'sessionId',
    credentialEpoch: 'credentialEpoch',
    configRevision: 'configRevision',
    dispatchRevision: 'dispatchRevision',
    dispatchDaemonId: 'dispatchDaemonId',
    reviewPolicySnapshot: 'reviewPolicySnapshot',
    reportingModeSnapshot: 'reportingModeSnapshot',
    gateModeSnapshot: 'gateModeSnapshot',
    leaseOwner: 'leaseOwner',
    leaseUntil: 'leaseUntil',
    nextAttemptAt: 'nextAttemptAt',
    attempts: 'attempts',
    lastErrorCode: 'lastErrorCode',
    pendingIntent: 'pendingIntent',
    writeMarker: 'writeMarker',
    writePhase: 'writePhase',
    writeStartedAt: 'writeStartedAt',
    tombstonedAt: 'tombstonedAt',
    updatedAt: 'updatedAt'
};
export const RelayScalarFieldEnum = {
    id: 'id',
    name: 'name',
    daemonUrl: 'daemonUrl',
    features: 'features',
    lastSeenAt: 'lastSeenAt',
    createdAt: 'createdAt'
};
export const BotScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    platform: 'platform',
    name: 'name',
    prebuilt: 'prebuilt',
    slackAppId: 'slackAppId',
    teamId: 'teamId',
    workspaceId: 'workspaceId',
    workspaceName: 'workspaceName',
    botUserId: 'botUserId',
    revokedAt: 'revokedAt',
    credentialRevision: 'credentialRevision',
    credentialInstalledAt: 'credentialInstalledAt',
    grantedScopes: 'grantedScopes',
    externalAppId: 'externalAppId',
    externalTenantId: 'externalTenantId',
    platformConfig: 'platformConfig',
    shareable: 'shareable',
    transport: 'transport',
    createdByUserId: 'createdByUserId',
    lastUsedAt: 'lastUsedAt',
    lastAgentName: 'lastAgentName',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const BotSecretScalarFieldEnum = {
    botId: 'botId',
    botToken: 'botToken',
    appToken: 'appToken',
    signingSecret: 'signingSecret',
    verificationToken: 'verificationToken',
    encryptKey: 'encryptKey'
};
export const SharedThreadAgentScalarFieldEnum = {
    botId: 'botId',
    sessionKey: 'sessionKey',
    agentId: 'agentId',
    daemonId: 'daemonId',
    updatedAt: 'updatedAt'
};
export const SharedThreadParticipantScalarFieldEnum = {
    botId: 'botId',
    sessionKey: 'sessionKey',
    agentId: 'agentId',
    daemonId: 'daemonId',
    updatedAt: 'updatedAt'
};
export const IntegrationScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    botId: 'botId',
    platform: 'platform',
    name: 'name',
    status: 'status',
    revokedCredentialRevision: 'revokedCredentialRevision',
    feishuRegion: 'feishuRegion',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const IntegrationChannelScalarFieldEnum = {
    integrationId: 'integrationId',
    channelId: 'channelId',
    name: 'name',
    spaceId: 'spaceId',
    space: 'space',
    icon: 'icon',
    color: 'color',
    key: 'key',
    url: 'url',
    isPrivate: 'isPrivate',
    kind: 'kind',
    dmUserId: 'dmUserId',
    trigger: 'trigger',
    triggerChosen: 'triggerChosen',
    agentId: 'agentId',
    firstSeenAt: 'firstSeenAt',
    updatedAt: 'updatedAt'
};
export const SlackInstallScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    appId: 'appId',
    clientId: 'clientId',
    clientSecret: 'clientSecret',
    botToken: 'botToken',
    name: 'name',
    transport: 'transport',
    signingSecret: 'signingSecret',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt'
};
export const SlackPlatformInstallScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    status: 'status',
    failureReason: 'failureReason',
    missingScopes: 'missingScopes',
    botId: 'botId',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    settledAt: 'settledAt'
};
export const FeishuAppRegistrationScalarFieldEnum = {
    id: 'id',
    targetKey: 'targetKey',
    orgId: 'orgId',
    agentId: 'agentId',
    requestedName: 'requestedName',
    fallbackRegion: 'fallbackRegion',
    transport: 'transport',
    authorizationUrl: 'authorizationUrl',
    providerDomain: 'providerDomain',
    deviceCode: 'deviceCode',
    intervalMs: 'intervalMs',
    nextPollAt: 'nextPollAt',
    expiresAt: 'expiresAt',
    status: 'status',
    failureReason: 'failureReason',
    appId: 'appId',
    appSecret: 'appSecret',
    resolvedRegion: 'resolvedRegion',
    botId: 'botId',
    integrationId: 'integrationId',
    createdByUserId: 'createdByUserId',
    claimToken: 'claimToken',
    claimedUntil: 'claimedUntil',
    createdAt: 'createdAt',
    settledAt: 'settledAt'
};
export const SlackUserConfigScalarFieldEnum = {
    orgId: 'orgId',
    userId: 'userId',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    accessExpiresAt: 'accessExpiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const LinearTokenScalarFieldEnum = {
    orgId: 'orgId',
    clientId: 'clientId',
    organizationId: 'organizationId',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const LinearInstallStateScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    defaultAgentId: 'defaultAgentId',
    status: 'status',
    failureReason: 'failureReason',
    botId: 'botId',
    expectedBotId: 'expectedBotId',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    claimedAt: 'claimedAt',
    settledAt: 'settledAt'
};
export const AuditEventScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    kind: 'kind',
    daemonId: 'daemonId',
    agentId: 'agentId',
    sessionId: 'sessionId',
    actorUserId: 'actorUserId',
    frameType: 'frameType',
    frameCorr: 'frameCorr',
    message: 'message',
    details: 'details',
    createdAt: 'createdAt'
};
export const GithubInstallationScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    installationId: 'installationId',
    accountLogin: 'accountLogin',
    accountType: 'accountType',
    repositorySelection: 'repositorySelection',
    permissions: 'permissions',
    suspendedAt: 'suspendedAt',
    revokedAt: 'revokedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GithubInstallStateScalarFieldEnum = {
    nonce: 'nonce',
    orgId: 'orgId',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt'
};
export const GitlabConnectionScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    userId: 'userId',
    gitlabUserId: 'gitlabUserId',
    gitlabUsername: 'gitlabUsername',
    scopes: 'scopes',
    accessExpiresAt: 'accessExpiresAt',
    state: 'state',
    tokenVersion: 'tokenVersion',
    refreshLeaseOwner: 'refreshLeaseOwner',
    refreshLeaseUntil: 'refreshLeaseUntil',
    lastSyncAt: 'lastSyncAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GitlabConnectionSecretScalarFieldEnum = {
    connectionId: 'connectionId',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken'
};
export const GitlabProjectBindingScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    projectId: 'projectId',
    projectPath: 'projectPath',
    defaultBranch: 'defaultBranch',
    installerConnectionId: 'installerConnectionId',
    webhookId: 'webhookId',
    desiredEventsHash: 'desiredEventsHash',
    credentialEpoch: 'credentialEpoch',
    convergeOwedAt: 'convergeOwedAt',
    state: 'state',
    stateReason: 'stateReason',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GitlabAgentAccountScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    agentId: 'agentId',
    rootGroupId: 'rootGroupId',
    serviceAccountUserId: 'serviceAccountUserId',
    username: 'username',
    displayName: 'displayName',
    avatarFingerprint: 'avatarFingerprint',
    createAttemptId: 'createAttemptId',
    createAttemptAt: 'createAttemptAt',
    createAttemptKnownIds: 'createAttemptKnownIds',
    credentialEpoch: 'credentialEpoch',
    administeringConnectionId: 'administeringConnectionId',
    leaseOwner: 'leaseOwner',
    leaseUntil: 'leaseUntil',
    generation: 'generation',
    lifecycle: 'lifecycle',
    retiringForBindingId: 'retiringForBindingId',
    state: 'state',
    stateReason: 'stateReason',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GitlabAccountMembershipScalarFieldEnum = {
    id: 'id',
    accountId: 'accountId',
    accountGeneration: 'accountGeneration',
    bindingId: 'bindingId',
    accessLevel: 'accessLevel',
    state: 'state',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GitlabProjectCredentialScalarFieldEnum = {
    id: 'id',
    accountId: 'accountId',
    purpose: 'purpose',
    externalTokenId: 'externalTokenId',
    scopes: 'scopes',
    providerExpiresAt: 'providerExpiresAt',
    generation: 'generation',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GitlabProjectCredentialSecretScalarFieldEnum = {
    credentialId: 'credentialId',
    token: 'token'
};
export const GitlabWebhookSecretScalarFieldEnum = {
    bindingId: 'bindingId',
    signingKey: 'signingKey'
};
export const GitlabOauthStateScalarFieldEnum = {
    nonce: 'nonce',
    orgId: 'orgId',
    userId: 'userId',
    browserHash: 'browserHash',
    returnPath: 'returnPath',
    verifier: 'verifier',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt'
};
export const GitlabInstanceStateScalarFieldEnum = {
    baseUrl: 'baseUrl',
    version: 'version',
    enterprise: 'enterprise',
    observedAt: 'observedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GiteaConnectionScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    createdByUserId: 'createdByUserId',
    botUserId: 'botUserId',
    botUsername: 'botUsername',
    botDisplayName: 'botDisplayName',
    credentialEpoch: 'credentialEpoch',
    instanceVersion: 'instanceVersion',
    state: 'state',
    lastVerifiedAt: 'lastVerifiedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GiteaConnectionSecretScalarFieldEnum = {
    connectionId: 'connectionId',
    token: 'token'
};
export const GiteaRepositoryBindingScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    connectionId: 'connectionId',
    repoId: 'repoId',
    repoPath: 'repoPath',
    cloneUrl: 'cloneUrl',
    defaultBranch: 'defaultBranch',
    webhookId: 'webhookId',
    nextWebhookId: 'nextWebhookId',
    desiredEventsHash: 'desiredEventsHash',
    lastVerifiedDeliveryAt: 'lastVerifiedDeliveryAt',
    convergeOwedAt: 'convergeOwedAt',
    state: 'state',
    stateReason: 'stateReason',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const GiteaWebhookSecretScalarFieldEnum = {
    bindingId: 'bindingId',
    signingKey: 'signingKey',
    nextSigningKey: 'nextSigningKey'
};
export const McpProviderScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    name: 'name',
    kind: 'kind',
    auth: 'auth',
    transport: 'transport',
    url: 'url',
    visibility: 'visibility',
    sharedWith: 'sharedWith',
    ui: 'ui',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const McpProviderSecretScalarFieldEnum = {
    mcpProviderId: 'mcpProviderId',
    headers: 'headers'
};
export const McpGrantScalarFieldEnum = {
    id: 'id',
    mcpProviderId: 'mcpProviderId',
    key: 'key',
    status: 'status',
    createdAt: 'createdAt'
};
export const McpProviderOauthScalarFieldEnum = {
    mcpProviderId: 'mcpProviderId',
    resource: 'resource',
    issuer: 'issuer',
    authorizationEndpoint: 'authorizationEndpoint',
    tokenEndpoint: 'tokenEndpoint',
    registrationEndpoint: 'registrationEndpoint',
    scopes: 'scopes',
    clientId: 'clientId',
    clientSource: 'clientSource',
    issParameterSupported: 'issParameterSupported',
    status: 'status',
    connectedByUserId: 'connectedByUserId',
    accessExpiresAt: 'accessExpiresAt',
    tokenVersion: 'tokenVersion',
    refreshLeaseOwner: 'refreshLeaseOwner',
    refreshLeaseUntil: 'refreshLeaseUntil',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const McpProviderOauthSecretScalarFieldEnum = {
    mcpProviderId: 'mcpProviderId',
    clientSecret: 'clientSecret',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken'
};
export const McpProviderOauthStateScalarFieldEnum = {
    nonce: 'nonce',
    mcpProviderId: 'mcpProviderId',
    orgId: 'orgId',
    userId: 'userId',
    browserHash: 'browserHash',
    returnPath: 'returnPath',
    verifier: 'verifier',
    expectedIssuer: 'expectedIssuer',
    expectedVersion: 'expectedVersion',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt'
};
export const SkillSourceScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    name: 'name',
    source: 'source',
    githubRepoId: 'githubRepoId',
    ref: 'ref',
    subDir: 'subDir',
    skills: 'skills',
    private: 'private',
    visibility: 'visibility',
    sharedWith: 'sharedWith',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const OrganizationEnvironmentEntryScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    key: 'key',
    kind: 'kind',
    variableValue: 'variableValue',
    audience: 'audience',
    version: 'version',
    createdByUserId: 'createdByUserId',
    lastModifiedByUserId: 'lastModifiedByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const OrganizationEnvironmentSecretScalarFieldEnum = {
    entryId: 'entryId',
    value: 'value',
    updatedAt: 'updatedAt'
};
export const OrganizationEnvironmentAssignmentScalarFieldEnum = {
    orgId: 'orgId',
    entryId: 'entryId',
    agentId: 'agentId',
    authorizedByUserId: 'authorizedByUserId',
    createdAt: 'createdAt'
};
export const OrganizationKnowledgeScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    title: 'title',
    currentRevision: 'currentRevision',
    archivedAt: 'archivedAt',
    archivedByUserId: 'archivedByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const OrganizationKnowledgeRevisionScalarFieldEnum = {
    knowledgeId: 'knowledgeId',
    revision: 'revision',
    content: 'content',
    summary: 'summary',
    tags: 'tags',
    digest: 'digest',
    source: 'source',
    sourceAgentId: 'sourceAgentId',
    sourceDreamId: 'sourceDreamId',
    sourceCandidateId: 'sourceCandidateId',
    sourceSessionIds: 'sourceSessionIds',
    createdByUserId: 'createdByUserId',
    reviewedByUserId: 'reviewedByUserId',
    createdAt: 'createdAt'
};
export const ManagedSkillScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    name: 'name',
    description: 'description',
    currentRevision: 'currentRevision',
    archivedAt: 'archivedAt',
    archivedByUserId: 'archivedByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ManagedSkillRevisionScalarFieldEnum = {
    managedSkillId: 'managedSkillId',
    revision: 'revision',
    archive: 'archive',
    digest: 'digest',
    compressedBytes: 'compressedBytes',
    expandedBytes: 'expandedBytes',
    fileCount: 'fileCount',
    manifest: 'manifest',
    source: 'source',
    sourceAgentId: 'sourceAgentId',
    sourceDreamId: 'sourceDreamId',
    sourceCandidateId: 'sourceCandidateId',
    sourceSessionIds: 'sourceSessionIds',
    createdByUserId: 'createdByUserId',
    reviewedByUserId: 'reviewedByUserId',
    createdAt: 'createdAt'
};
export const OrganizationSuggestionScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    sourceAgentId: 'sourceAgentId',
    sourceDaemonId: 'sourceDaemonId',
    dreamId: 'dreamId',
    candidateId: 'candidateId',
    kind: 'kind',
    operation: 'operation',
    targetArtifactId: 'targetArtifactId',
    targetRevision: 'targetRevision',
    title: 'title',
    summary: 'summary',
    tags: 'tags',
    digest: 'digest',
    contentBytes: 'contentBytes',
    sessionIds: 'sessionIds',
    state: 'state',
    reviewedByUserId: 'reviewedByUserId',
    reviewedAt: 'reviewedAt',
    reviewReason: 'reviewReason',
    acceptedArtifactId: 'acceptedArtifactId',
    acceptedArtifactRevision: 'acceptedArtifactRevision',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MemoryPluginInstallationScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    pluginId: 'pluginId',
    transport: 'transport',
    endpoint: 'endpoint',
    commandRef: 'commandRef',
    pinnedProfileMajor: 'pinnedProfileMajor',
    expectedManifestDigest: 'expectedManifestDigest',
    secretHeaders: 'secretHeaders',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ExternalMemoryConnectionScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    installationId: 'installationId',
    config: 'config',
    status: 'status',
    revision: 'revision',
    probedRevision: 'probedRevision',
    pluginVersion: 'pluginVersion',
    profile: 'profile',
    manifestDigest: 'manifestDigest',
    capabilities: 'capabilities',
    declaredEgressHosts: 'declaredEgressHosts',
    reasonCode: 'reasonCode',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ExternalMemoryConnectionSecretScalarFieldEnum = {
    connectionId: 'connectionId',
    values: 'values'
};
export const ExternalMemoryGrantScalarFieldEnum = {
    id: 'id',
    connectionId: 'connectionId',
    key: 'key',
    status: 'status',
    createdAt: 'createdAt'
};
export const DutyGroupScalarFieldEnum = {
    id: 'id',
    orgId: 'orgId',
    holder: 'holder',
    term: 'term',
    expiresAt: 'expiresAt',
    confirmedTerm: 'confirmedTerm',
    confirmedHolder: 'confirmedHolder',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DutyGroupMemberScalarFieldEnum = {
    kind: 'kind',
    refId: 'refId',
    groupId: 'groupId',
    orgId: 'orgId'
};
export const AgentMemoryFileScalarFieldEnum = {
    agentId: 'agentId',
    orgId: 'orgId',
    path: 'path',
    content: 'content',
    size: 'size',
    mtime: 'mtime',
    stagedAt: 'stagedAt'
};
export const AgentMemoryHistoryScalarFieldEnum = {
    id: 'id',
    seq: 'seq',
    agentId: 'agentId',
    orgId: 'orgId',
    root: 'root',
    path: 'path',
    event: 'event',
    before: 'before',
    after: 'after',
    at: 'at',
    source: 'source',
    truncated: 'truncated',
    bytes: 'bytes'
};
export const AgentMemoryMutationScalarFieldEnum = {
    agentId: 'agentId',
    operationId: 'operationId',
    orgId: 'orgId',
    root: 'root',
    requestHash: 'requestHash',
    source: 'source',
    sourceTurnId: 'sourceTurnId',
    committedAt: 'committedAt',
    receipt: 'receipt'
};
export const SortOrder = {
    asc: 'asc',
    desc: 'desc'
};
export const JsonNullValueInput = {
    JsonNull: JsonNull
};
export const NullableJsonNullValueInput = {
    DbNull: DbNull,
    JsonNull: JsonNull
};
export const JsonNullValueFilter = {
    DbNull: DbNull,
    JsonNull: JsonNull,
    AnyNull: AnyNull
};
export const QueryMode = {
    default: 'default',
    insensitive: 'insensitive'
};
export const NullsOrder = {
    first: 'first',
    last: 'last'
};
export const defineExtension = runtime.Extensions.defineExtension;
//# sourceMappingURL=prismaNamespace.js.map